import React, {useState} from 'react';
import Post from './components/Post';
import AuthShell from './components/AuthShell';
import {FaGift, FaKey, FaMobileAlt, FaUser} from 'react-icons/fa';

const PostFree = () => {
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [referral, setReferral] = useState('');
  const [loading, setLoading] = useState(false);

  const handleInputChange = setter => e => {
    setter(e.target.value);
  };

  const register = async () => {
    if (!name) {
      alert('Name is required');
      return;
    }
    if (!mobile) {
      alert('Mobile is required');
      return;
    }
    if (!password) {
      alert('Password is required');
      return;
    }

    setLoading(true);
    try {
      const res = await Post.Signup({name, mobile, password, referral});
      if (!res.error) {
        if (res.id) {
          window.location.href = `/otp?type=signup&id=${res.id}`;
        } else {
          alert('Successfully registered!');
          window.location.href = '/';
        }
      } else {
        alert('Error: ' + res.errorMsg);
      }
    } catch (error) {
      alert('Unable to register. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create Account" loading={loading}>
      <form
        className="auth-form"
        onSubmit={event => {
          event.preventDefault();
          register();
        }}>
        <label className="auth-field">
          <FaUser className="auth-field-icon" size={20} />
          <input
            className="auth-input"
            type="text"
            placeholder="Name"
            aria-label="Name"
            value={name}
            onChange={handleInputChange(setName)}
          />
        </label>
        <label className="auth-field">
          <FaMobileAlt className="auth-field-icon" size={20} />
          <input
            className="auth-input"
            type="tel"
            inputMode="numeric"
            autoComplete="tel"
            maxLength={10}
            placeholder="Mobile Number"
            aria-label="Mobile Number"
            value={mobile}
            onChange={handleInputChange(setMobile)}
          />
        </label>
        <label className="auth-field">
          <FaKey className="auth-field-icon" size={20} />
          <input
            className="auth-input"
            type="password"
            autoComplete="new-password"
            placeholder="Password"
            aria-label="Password"
            value={password}
            onChange={handleInputChange(setPassword)}
          />
        </label>
        <label className="auth-field">
          <FaGift className="auth-field-icon" size={20} />
          <input
            className="auth-input"
            type="text"
            placeholder="Referral Code (optional)"
            aria-label="Referral Code (optional)"
            value={referral}
            onChange={handleInputChange(setReferral)}
          />
        </label>
        <button className="auth-submit" type="submit" disabled={loading}>
          {loading ? 'Please wait...' : 'Register'}
        </button>
      </form>

      <div className="auth-footer">
        <span>Already registered?</span>
        <button
          className="auth-link"
          type="button"
          onClick={() => {
            window.location.href = '/';
          }}>
          Login
        </button>
      </div>
    </AuthShell>
  );
};

export default PostFree;
